import { useTranslation } from "react-i18next";
import { PrintDialog } from "../../../utils/printDialog";
import { getPdfReport, printReport } from "../../../../api/service/report";

export const ReportPrintDialog = (props) => {
  const { onClose, open, report, onRefresh } = props;
  const { t } = useTranslation();

  const config = {
    module: "report",
    title: t("Print Report"),
    printTypeParamName: "printReportType",
    printTypeOptions: [
      {
        name: "printReportType",
        value: "",
        label: t("Not Chosen"),
      },
      {
        name: "printReportType",
        value: "report",
        label: t("Report"),
      },
      {
        name: "printReportType",
        value: "customer_report",
        label: t("Customer Report"),
      },
      {
        name: "printReportType",
        value: "note",
        label: t("Note"),
      },
    ],
    getPdfFunction: getPdfReport,
    printFunction: printReport,
    // Pass pdf_customer_report_url if available
    existingPdfUrl: report?.pdf_customer_report_url || null,
  };

  return (
    <PrintDialog
      open={open}
      onClose={onClose}
      item={report}
      onRefresh={onRefresh}
      config={config}
    />
  );
};
